<template>
  <section class="news-hero">
    <div class="news-hero__wr">
      <div class="news-hero__top">
        <client-only>
          <nuxt-link
            :to="backTo || localePath('news')"
            class="news-hero__back"
            aria-label="Back to news index">
            <base-icon name="back" />
          </nuxt-link>
        </client-only>
        <div
          v-if="category"
          class="news-hero__category">
          {{ category.title }}
        </div>
      </div>

      <div class="news-hero__content">
        <h1
          v-if="title"
          class="news-hero__title">
          {{ title }}
        </h1>
        <h2
          v-if="description"
          class="news-hero__abstract">
          {{ description }}
        </h2>
        <h2
          v-else-if="abstract"
          class="news-hero__abstract">
          {{ abstract }}
        </h2>
        <div
          v-if="date"
          class="news-hero__date">
          {{ formatDate(date, 'dd/MM/yy', locale) }}
        </div>
      </div>
    </div>

    <div
      v-if="exists(image)"
      class="news-hero__image">
      <base-image v-bind="getFirst(image)" />
    </div>

    <div
      v-if="description"
      class="news-hero__desc">
      <div v-html="description" />
    </div>
  </section>
</template>

<script setup>
  import { formatDate } from '~/utils/dates'

  const { locale } = useI18n()
  const localePath = useLocalePath()
  const props = defineProps({
    title: String,
    category: [ Array, Object ],
    date: String,
    abstract: String,
    description: String,
    image: [ Array, Object ],
    backTo: String
  })
</script>

<style lang="scss" scoped>
.news-hero {
  padding-top: calc(var(--header-height) * 2);
  padding-bottom: calc(var(--header-height) / 2);

  &__wr {
    @include wrapper;
  }

  &__category {
    text-transform: uppercase;
    justify-self: center;
    text-align: center;
  }

  &__date {
    color: var(--color-red);
  }

  &__back {
    width: rem(60px);
    height: rem(60px);
    display: flex;
    align-items: center;
    color: var(--color-red);
    transition: opacity 0.3s;

    &:hover {
      opacity: 0.5;
    }
  }

  &__top {
    display: grid;
    align-items: center;
    grid-template-columns: repeat(3, minmax(0, 1fr));
    column-gap: var(--grid-gutter);
    margin-bottom: rem(32px);
  }

  &__title {
    @include title-xl;

    font-weight: normal;
    text-align: center;
  }

  &__content {
    display: flex;
    gap: rem(32px);
    flex-direction: column;
    align-items: center;
    text-align: center;
    max-width: rem(800px);
    margin: 0 auto;
  }

  &__abstract {
    font-weight: normal;

    @include body-m;
  }

  &__image {
    padding-top: rem(80px);
  }

  &__desc {
    @include container;
    @include wrapper;
    @include blocks-padding-top;
  }

  &__desc > div {
    grid-column: 1 / span 12;

    @include mq(medium) {
      grid-column: 4 / span 6;
    }
  }
}
</style>
